import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";
import React from "../web_modules/react.js";
import { useAsyncStatus, AsyncStates } from "../web_modules/use-async-status.js";
import { LoadingButton } from "../web_modules/@ticketbutler/toolbox.js"; // @ts-expect-error: TODO: Type this

import serialize from "../web_modules/for-cerial.js";
import Select from "../web_modules/react-select.js";
import { API_HOST, useLanguage, getFieldError, buttonCheckMark, getThemedButton, FieldErrors, makeTbRequestHeaders, getOrderSummaryFromPurchase, styles, makeSearchParamString } from "./app.js";
import { useScrollToError } from "./shared.js";
import { useHistory, useParams } from "../web_modules/react-router-dom.js";
import { useTranslation } from "../web_modules/react-i18next.js";
const extrasTypesStyles = {
  select: {
    fontSize: 18,
    padding: 20,
    minHeight: 35,
    width: "100%"
  },
  smallSubtitle: {
    textTransform: "uppercase",
    fontSize: 13,
    fontWeight: 600,
    color: "#63696d",
    marginBottom: 0
  }
};

var _StyledDiv = _styled("div").withConfig({
  displayName: "extras___StyledDiv",
  componentId: "sc-12d4le2-0"
})({
  width: "75%",
  margin: "auto",
  "@media (max-width: 760px)": {
    width: "100%"
  }
});

var _StyledP = _styled("p").withConfig({
  displayName: "extras___StyledP",
  componentId: "sc-12d4le2-1"
})(["", ""], p => p._css);

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "extras___StyledDiv2",
  componentId: "sc-12d4le2-2"
})({
  width: "65%",
  margin: "auto",
  padding: "20px 0 40px",
  borderBottom: "1px solid #eee",
  "@media (max-width: 1050px)": {
    width: "90%"
  }
});

var _StyledP2 = _styled("p").withConfig({
  displayName: "extras___StyledP2",
  componentId: "sc-12d4le2-3"
})({
  textTransform: "uppercase",
  fontWeight: "bold",
  marginBottom: 7
});

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "extras___StyledDiv3",
  componentId: "sc-12d4le2-4"
})({
  marginBottom: 10
});

var _StyledSpan = _styled("span").withConfig({
  displayName: "extras___StyledSpan",
  componentId: "sc-12d4le2-5"
})({
  marginLeft: 15,
  fontSize: 13,
  fontWeight: "bold",
  marginTop: 7
});

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "extras___StyledDiv4",
  componentId: "sc-12d4le2-6"
})({
  marginBottom: 10
});

var _StyledSpan2 = _styled("span").withConfig({
  displayName: "extras___StyledSpan2",
  componentId: "sc-12d4le2-7"
})({
  marginLeft: 15,
  fontSize: 13,
  fontWeight: "bold",
  marginTop: 7
});

var _StyledSpan3 = _styled("span").withConfig({
  displayName: "extras___StyledSpan3",
  componentId: "sc-12d4le2-8"
})({
  fontSize: 12
});

var _StyledImg = _styled("img").withConfig({
  displayName: "extras___StyledImg",
  componentId: "sc-12d4le2-9"
})({
  width: "90%",
  padding: "10px 0",
  objectFit: "cover",
  maxHeight: 350,
  display: "block",
  margin: "20 auto 20 auto",
  "@media (max-width: 760px)": {
    // Full width in mobile view
    width: "100%"
  }
});

var _StyledP3 = _styled("p").withConfig({
  displayName: "extras___StyledP3",
  componentId: "sc-12d4le2-10"
})(["", ""], p => p._css2);

var _StyledP4 = _styled("p").withConfig({
  displayName: "extras___StyledP4",
  componentId: "sc-12d4le2-11"
})({
  color: "#63696d",
  fontSize: 13,
  marginTop: 0,
  textAlign: "justify"
});

var _StyledP5 = _styled("p").withConfig({
  displayName: "extras___StyledP5",
  componentId: "sc-12d4le2-12"
})(["", ""], p => p._css3);

var _StyledDiv5 = _styled("div").withConfig({
  displayName: "extras___StyledDiv5",
  componentId: "sc-12d4le2-13"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  marginTop: 20
});

var _StyledButton = _styled("button").withConfig({
  displayName: "extras___StyledButton",
  componentId: "sc-12d4le2-14"
})(["", ""], p => p._css4);

var _StyledDiv6 = _styled("div").withConfig({
  displayName: "extras___StyledDiv6",
  componentId: "sc-12d4le2-15"
})(["", ""], p => p._css5);

export function ExtrasTypes({
  theme,
  event,
  reservation,
  registrationFormValues,
  whitelabel,
  setRegistrationFormValues,
  setOrderSummary,
  setReservation,
  onSuccess
}) {
  const language = useLanguage();
  const {
    eventSlug
  } = useParams();
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const defaultSelectableExtras = 9; //get existing extras types on the event

  const {
    trigger: getExtrasTypes,
    lastResult: extrasTypes // TODO: Show GET errors: lastError: extrasTypesErrors,

  } = useAsyncStatus(async function getExtrasTypes() {
    const req = await fetch([API_HOST, "events", event.uuid, "checkout/extras-types/"].join("/"), {
      headers: makeTbRequestHeaders(language)
    });

    if (req.ok) {
      const res = await req.json();
      return res;
    } else {
      throw Error();
    }
  }, [language]);
  React.useEffect(() => {
    getExtrasTypes();
  }, [getExtrasTypes]); // post to backend the selected extras types

  const {
    trigger: selectExtrasTypes,
    lastError: selectedExtrasErrors,
    status: selectExtrasStatus
  } = useAsyncStatus(async function selectExtrasTypes(values) {
    const req = await fetch([API_HOST, "purchases", reservation.purchase.uuid, "extras/"].join("/"), {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify(values)
    });

    if (req.ok) {
      const res = await req.json();
      setOrderSummary(summary => ({ ...summary,
        ...getOrderSummaryFromPurchase(res.purchase)
      }));
      setReservation(res);
      onSuccess(reservation);
    } else {
      const res = await req.json();
      throw res;
    }
  }, [reservation.purchase.purchase_is_free], 2000);
  useScrollToError(Boolean(selectedExtrasErrors));
  return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(_StyledP, {
    _css: styles.checkoutModalHeading
  }, t("event.selectAdditionalProducts")), /*#__PURE__*/React.createElement("form", {
    onSubmit: function (e) {
      e.preventDefault();
      const values = serialize(e.target, {
        hash: true
      });
      const formData = Object.entries(values).reduce(function (acc, [key, value]) {
        //if attributes selected for extras
        if (typeof value === "object") {
          const countObj = value.reduce((accu, cur) => {
            accu[cur] = (accu[cur] || 0) + 1;
            return accu;
          }, {});
          acc[key] = countObj;
        } else {
          acc[key] = value;
        }

        return acc;
      }, {}); // Retain the values in case the user goes somewhere and wants to come back

      setRegistrationFormValues(v => ({ ...v,
        extras: values
      })); // Send to the backend only the values user selected

      selectExtrasTypes(formData);
    }
  }, extrasTypes && extrasTypes.length > 0 ? extrasTypes.filter(extrasType => extrasType.active === true).map(extrasType => {
    const soldOut = extrasType.amount_left < 1;
    const amountLimits = [extrasType.amount_left, extrasType.limit];
    const amountSelectable = Math.min(...amountLimits) + 1; //create options for extras attribute

    const attributeOptions = extrasType.attributes.length > 0 ? extrasType.attributes.reduce((acc, attribute) => {
      for (const [key, value] of Object.entries(attribute)) {
        acc.push({
          value: key,
          label: value.name,
          sort_id: value.sort_id
        });
      }

      return acc;
    }, []).sort(function (a, b) {
      return (a.sort_id || 0) - (b.sort_id || 0);
    }) : [];
    let defaultAmountType;

    if (registrationFormValues.extras) {
      defaultAmountType = registrationFormValues.extras[extrasType.uuid];
    }

    let defaultAmount;

    if (typeof defaultAmountType === "object") {
      // The total of the attributes list
      defaultAmount = defaultAmountType.length;
    } else if (defaultAmountType) {
      defaultAmount = parseInt(defaultAmountType);
    } //Create a flat list of selected attribute UUIDs so the UI can render an input for each attribute selection


    const defaultSelectedAttributes = typeof defaultAmountType === "object" ? defaultAmountType.reduce(function (acc, attributeID) {
      attributeOptions.map((option, index) => {
        if (attributeID === option?.value) {
          acc.push(index);
        }
      });
      return acc;
    }, []) : [];
    let extrasItemsSelector;

    switch (true) {
      case soldOut && !defaultAmount:
        extrasItemsSelector = /*#__PURE__*/React.createElement("span", null, t("event.soldOut"));
        break;

      default:
        {
          const quantityLength = defaultAmount ? defaultSelectableExtras < defaultAmount + amountSelectable ? defaultSelectableExtras + 1 : defaultAmount + amountSelectable : amountSelectable;
          extrasItemsSelector = /*#__PURE__*/React.createElement(SelectItemsPicker, {
            defaultValue: defaultAmount,
            defaultSelectedAttributes: defaultSelectedAttributes,
            quantLength: quantityLength,
            attributeOptions: attributeOptions,
            extraTypeId: extrasType.uuid,
            constraint_definition: extrasType.constraint_definition
          });
        }
    }

    return /*#__PURE__*/React.createElement(_StyledDiv2, {
      key: extrasType.uuid
    }, /*#__PURE__*/React.createElement(_StyledP2, null, extrasType.title), extrasType.is_free ? /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement(_StyledSpan, null, t("event.free").toLowerCase())) : /*#__PURE__*/React.createElement(_StyledDiv4, null, /*#__PURE__*/React.createElement(_StyledSpan2, null, whitelabel.numberFormat(event.eventsettings.show_price_with_vat ? Number(extrasType.price) : Number(extrasType.price) / (1 + whitelabel.vat / 100))), parseInt(extrasType.price) > 0 && !event.eventsettings.organizer_absorb_fees && /*#__PURE__*/React.createElement(_StyledSpan3, null, "+ ", whitelabel.numberFormat(extrasType.fee), " ", t("event.fee"))), extrasType.image && /*#__PURE__*/React.createElement(_StyledImg, {
      src: extrasType.image
    }), extrasType.description && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledP3, {
      _css2: extrasTypesStyles.smallSubtitle
    }, t("event.about")), /*#__PURE__*/React.createElement(_StyledP4, null, " ", /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: extrasType.description
      }
    }))), /*#__PURE__*/React.createElement(FieldErrors, {
      errors: getFieldError(selectedExtrasErrors, extrasType.title)
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledP5, {
      _css3: extrasTypesStyles.smallSubtitle
    }, t("event.quantity")), extrasItemsSelector));
  }) : /*#__PURE__*/React.createElement("span", null, t("event.gettingAdditionalProducts")), /*#__PURE__*/React.createElement(_StyledDiv5, null, /*#__PURE__*/React.createElement(LoadingButton, {
    loading: selectExtrasStatus === AsyncStates.Pending,
    success: selectExtrasStatus === AsyncStates.Success,
    successMessage: buttonCheckMark
  }, /*#__PURE__*/React.createElement(_StyledButton, {
    type: "submit",
    _css4: [getThemedButton(theme), {
      marginTop: 15
    }]
  }, t("event.continue"))), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(selectedExtrasErrors, "non_field_errors")
  }), /*#__PURE__*/React.createElement(_StyledDiv6, {
    role: "button",
    onClick: function () {
      history.push([`/${language}/e`, eventSlug, makeSearchParamString(["purchase_uuid", undefined])].filter(Boolean).join("/"));
    },
    _css5: [styles.textButton, {
      color: "#63696d",
      marginTop: 10,
      fontSize: 12
    }]
  }, t("event.back")))));
}
export function SelectItemsPicker({
  quantLength,
  defaultValue,
  attributeOptions,
  defaultSelectedAttributes,
  extraTypeId,
  constraint_definition
}) {
  const {
    t
  } = useTranslation();
  const [itemQuantity, setItemQuantity] = React.useState(defaultValue || 0); // Create options for item quantity

  const listOfOption = [];

  if (constraint_definition) {
    constraint_definition.forEach(n => {
      const singleObj = {};
      singleObj["value"] = n;
      singleObj["label"] = n;
      listOfOption.push(singleObj);
    });
  } else {
    Array.from({
      length: quantLength
    }).map((_, i) => {
      const singleObj = {};
      singleObj["value"] = i;
      singleObj["label"] = i;
      listOfOption.push(singleObj);
    });
  }

  const extraInputName = attributeOptions.length == 0 ? extraTypeId : undefined;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
    "data-testid": "select-quant",
    options: listOfOption,
    defaultValue: listOfOption[defaultValue || 0],
    isSearchable: false //if no attributes then consider extra amount value
    ,
    name: extraInputName,
    onChange: value => {
      const quantitySelected = value?.value;

      if (quantitySelected) {
        setItemQuantity(quantitySelected);
      }
    }
  }), // Attribute inputs
  itemQuantity > 0 && attributeOptions.length > 0 && Array.from({
    length: itemQuantity
  }).map((_, i) => /*#__PURE__*/React.createElement("div", {
    key: i
  }, /*#__PURE__*/React.createElement("p", null, t("event.selectItemVariation"), " ", i + 1, ":"), /*#__PURE__*/React.createElement(Select, {
    "data-testid": "select-attribute",
    isSearchable: false,
    name: `${extraTypeId}[]`,
    options: attributeOptions,
    defaultValue: attributeOptions[defaultSelectedAttributes[i]],
    required: true
  }))));
}